import { IMethod, IRequestParams, IResponse, ISimpleResponse } from '@dash/apiInstance';
import { all, call, put, takeEvery } from 'redux-saga/effects';
import { sendRequest } from 'src/helpers/saga';
import { t } from 'src/i18n';
import { executeAction } from 'src/helpers/api';
import { logger } from 'src/helpers/logger';
import ApiInstance from 'src/helpers/apiInstance';
import notifications from '../../../../../redux/notifications/actions';
import actionTypes from './actionTypes';
import { AddNewSkillRequestAction, ProcessActionRequestAction } from './actions.d';
import { IAddNewSkillResponse, IProcessActionResponse } from './types.d';
import actions from './actions';
import skillsActions from '../actions';

const addNewSkillApi = new ApiInstance('workers/:worker_id/positions/:position_id/competencies');

function* processAction({ payload }: ProcessActionRequestAction<{}, {}>) {
  try {
    const { url, method, data, key } = payload;

    const params: { url?: string; method?: IMethod; data?: any } = { url, method };

    if (method?.toLowerCase() !== 'get') {
      params.data = data;
    }

    const result: IResponse<IProcessActionResponse> = yield call<any, IRequestParams<{}, {}>, string>(
      sendRequest,
      executeAction,
      params,
      notifications.REQUEST_ERROR,
    );

    if (result?.status === 200) {
      if (key === 'add_skill_form_data') {
        yield put(
          actions.loadFormInfoSuccess({
            // @ts-ignore
            formInfo: result.data?.success?.data,
          }),
        );
      } else {
        yield put(
          notifications.addNotification({
            headline: t('dash.common.notification.success_headline'),
            type: 'success',
            message: result?.messages?.join(' ') || '',
          }),
        );
      }
    } else {
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.error_headline'),
          type: 'error',
          message: t('dash.common.notification.something_went_wrong'),
        }),
      );
    }

    yield put({ type: actionTypes.PROCESS_ACTION_ERROR });
  } catch (error) {
    logger.error(error);
  }
}

function* addNewSkill({ payload }: AddNewSkillRequestAction) {
  const { level, workerId, positionId } = payload;

  try {
    const result: ISimpleResponse<IAddNewSkillResponse> = yield call<any, IRequestParams<{}, {}>, string>(
      sendRequest,
      addNewSkillApi.post,
      { data: { level }, pathParams: { worker_id: workerId, position_id: positionId } },
      notifications.REQUEST_ERROR,
    );

    if (result.status === 200) {
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.clients.components.addNewSkillModal.add_skill_success_message'),
        }),
      );

      yield put(actions.changeModalVisibility({}));
      yield put(skillsActions.loadActiveSkillsRequest({ id: workerId }));
      yield put(actions.clearState());
    } else {
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.error_headline'),
          type: 'error',
          message: t('dash.common.notification.something_went_wrong'),
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actionTypes.PROCESS_ACTION_REQUEST, processAction)]);
  yield all([takeEvery(actionTypes.ADD_NEW_SKILL_REQUEST, addNewSkill)]);
}
